import React from 'react';
import EvaluacionesCuantitativas2Table from './TableEvaluacionesCuantitativas2/EvaluacionesCuantitativas2';

const EvaluacionesCuantitativas2 = () => {
  return <EvaluacionesCuantitativas2Table/> ;
};

export default EvaluacionesCuantitativas2;
